// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import KpiWidgetsPage from './KpiWidgetsPage';
import LineChartWidgetsPage from './LineChartWidgetsPage';
import BarChartWidgetsPage from './BarChartWidgetsPage';
import PieChartWidgetsPage from './PieChartWidgetsPage';
import AreaChartWidgetsPage from './AreaChartWidgetsPage';
import DataTableWidgetsPage from './DataTableWidgetsPage';
import GaugeWidgetsPage from './GaugeWidgetsPage';
import HeatmapWidgetsPage from './HeatmapWidgetsPage';
import AlertWidgetsPage from './AlertWidgetsPage';
import AiInsightWidgetsPage from './AiInsightWidgetsPage';

export default function WidgetsRoutes() {
  return (
    <Routes>
      <Route path="kpi" element={<KpiWidgetsPage />} />
      <Route path="line-chart" element={<LineChartWidgetsPage />} />
      <Route path="bar-chart" element={<BarChartWidgetsPage />} />
      <Route path="pie-chart" element={<PieChartWidgetsPage />} />
      <Route path="area-chart" element={<AreaChartWidgetsPage />} />
      <Route path="data-table" element={<DataTableWidgetsPage />} />
      <Route path="gauges" element={<GaugeWidgetsPage />} />
      <Route path="heatmaps" element={<HeatmapWidgetsPage />} />
      <Route path="alerts" element={<AlertWidgetsPage />} />
      <Route path="ai-insights" element={<AiInsightWidgetsPage />} />
    </Routes>
  );
}
